import React, { ComponentProps } from 'react';
import { DefaultView, DeleteAction, OptionalEditView, Views } from '../../types/BlockWithViews';
import {
  BlockInteractions,
  Views as BlockInteractionsViews,
  DISPLAY_TYPE,
  createButtonObject,
} from '../../components/organisms/BlockInteractions';
import { asFetchableBlock, useBlockContext, useRefreshBlock } from '../../_lib/BlockFetcher';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { Icons } from '../../components/atoms/SVG';
import { BlockType } from '../../types/api/ElementType';
import { ProfileImageDefaultView } from './views/ProfileImageDefaultView';
import { ProfileImageEditView } from './views/ProfileImageEditView';

type ProfileImageProps = Views<
  DefaultView<ProfileImageDefaultView> & OptionalEditView<ProfileImageEditView> & DeleteAction
>;
function ProfileImage({ activeView = 'default', views }: ProfileImageProps) {
  const { t } = useSonTranslation('ProfileImage');
  const { uuid, elementType } = useBlockContext();
  const { refresh, refreshCount } = useRefreshBlock();

  const buttons = {
    ...(views.edit &&
      createButtonObject(
        BlockInteractionsViews.EDIT,
        Icons.EDIT_PENCIL,
        'ProfileImage:edit',
        DISPLAY_TYPE.COLLAPSIBLE,
        <ProfileImageEditView {...views.edit} />,
      )),
    ...(views.delete &&
      createButtonObject(BlockInteractionsViews.DELETE, Icons.ERASER, 'ProfileImage:delete', DISPLAY_TYPE.MODAL)),
  };

  return (
    <BlockInteractions
      uuid={uuid}
      elementType={elementType}
      headline={{ text: t('headline'), hierarchy: 2, visible: true }}
      views={views}
      activeView={activeView}
      buttons={buttons}
      refreshBlock={refresh}
      refreshCount={refreshCount}
    >
      <ProfileImageDefaultView {...views.default} />
    </BlockInteractions>
  );
}

export const ProfileImageBlock = asFetchableBlock(ProfileImage, BlockType.profileimage);
export type ProfileImageBlock = ComponentProps<typeof ProfileImageBlock>;
